import type { Configuration } from '@azure/msal-browser';
import { envOr } from '@/lib/env';

export type AuthMode = 'entra' | 'dev';

/** AUTH_MODE=dev (the default for local work) picks a seeded user instead of signing in. */
export const authMode = envOr(import.meta.env.VITE_AUTH_MODE, 'dev') as AuthMode;

export const ENTRA_CLIENT_ID = envOr(import.meta.env.VITE_ENTRA_CLIENT_ID, '7939cc88-8b2f-4ae4-a0fb-27441b7f569b');
export const ENTRA_TENANT_ID = envOr(import.meta.env.VITE_ENTRA_TENANT_ID, '01d3dc41-5ac8-440d-9b11-52068f9881d2');
export const API_SCOPE = envOr(import.meta.env.VITE_API_SCOPE, `api://${ENTRA_CLIENT_ID}/access_as_user`);

export const msalConfig: Configuration = {
  auth: {
    clientId: ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${ENTRA_TENANT_ID}`,
    redirectUri: typeof window === 'undefined' ? 'http://localhost:5173' : window.location.origin,
    postLogoutRedirectUri: typeof window === 'undefined' ? 'http://localhost:5173' : window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: { cacheLocation: 'sessionStorage', storeAuthStateInCookie: false },
};

export const loginRequest = { scopes: [API_SCOPE] };

// A production image built without VITE_AUTH_MODE=entra would serve the seeded-user picker to
// real users. That is a build-arg mistake, not a runtime mode, so say so loudly.
if (import.meta.env.PROD && authMode === 'dev') {
  console.warn('[cigs] AUTH_MODE=dev in a production build — set VITE_AUTH_MODE=entra in the image build args.');
}

export const DEV_USER_STORAGE_KEY = 'cigs-dev-user';
